import React from 'react';
import PropTypes from 'prop-types';

import CustomerMembershipInfo from './MembershipInfo';
import CustomerNoMembership from './MembershipInfo/NoMembership';
import InvoicesList from '../../../../memberships/invoices/InvoicesList';

const CustomerMembership = props => (
  <div className="s-v2 u-mt">
    <div className="layout__item">
      <CustomerMembershipInfo
        display-if={props.subscription}
        subscription={props.subscription}
        fetchSubscription={props.fetchSubscription}
        activeType={props.activeType}
        activeId={props.activeId}
      />
      <CustomerNoMembership
        display-if={!props.subscription}
        canSellMembership={props.canSellMembership}
        customer={props.initialValues}
      />
    </div>
    <div
      display-if={props.canSeeInvoices}
      className="u-p c-memberships c-memberships--rows-bordered c-memberships--header-padded"
    >
      <InvoicesList
        subscriptionId={props.subscription.id}
        showMemberName={false}
        title="Invoices"
        showActionsCompact
      />
    </div>
  </div>
);

CustomerMembership.propTypes = {
  activeId: PropTypes.string.isRequired,
  activeType: PropTypes.string.isRequired,
  fetchSubscription: PropTypes.func.isRequired,
  subscription: PropTypes.object,
  canSellMembership: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired,
  canSeeInvoices: PropTypes.bool.isRequired,
};

CustomerMembership.defaultProps = {
  subscription: null,
};

export default CustomerMembership;
